"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JsonRpcResponse = exports.JsonRpcRequest = exports.JuneoClient = exports.HttpsProtocol = exports.HttpProtocol = void 0;
const axios_1 = __importDefault(require("axios"));
const utils_1 = require("../utils");
const JsonRpcVersion = '2.0';
const HttpHeaders = {
    'Content-Type': 'application/json'
};
exports.HttpProtocol = 'http';
exports.HttpsProtocol = 'https';
const DefaultProtocol = exports.HttpsProtocol;
const Protocols = [exports.HttpProtocol, exports.HttpsProtocol];
class JuneoClient {
    nextRequestId = 1;
    protocol = DefaultProtocol;
    host = '';
    constructor() { }
    static parse(address) {
        const client = new JuneoClient();
        client.parseAddress(address);
        return client;
    }
    parseAddress(address) {
        const protocolSplit = address.split('://');
        const protocol = protocolSplit.length > 1 ? protocolSplit[0] : DefaultProtocol;
        const host = protocolSplit.length > 1 ? protocolSplit[1] : protocolSplit[0];
        this.setProtocol(protocol);
        this.host = host;
    }
    setProtocol(protocol) {
        if (!Protocols.includes(protocol)) {
            throw new utils_1.ProtocolError(`invalid protocol "${protocol}"`);
        }
        this.protocol = protocol;
    }
    getProtocol() {
        return this.protocol;
    }
    getNextRequestId() {
        return this.nextRequestId;
    }
    async rpcCall(endpoint, request) {
        const jsonRpcObject = request.getJsonRpcObject(this.nextRequestId++);
        const response = await this.post(endpoint, JSON.stringify(jsonRpcObject));
        const status = response.status;
        if (status < 200 || status >= 300) {
            throw new utils_1.HttpError(`request status is not accepted "${status}"`);
        }
        let data = response.data;
        if (typeof data === 'string') {
            data = JSON.parse(data);
        }
        if (data === null || data.error !== undefined) {
            throw new utils_1.JsonRpcError(data.error.message);
        }
        return new JsonRpcResponse(data.jsonrpc, data.id, data.result);
    }
    async post(endpoint, data) {
        return await axios_1.default
            .post(endpoint, data, {
            method: 'post',
            baseURL: `${this.protocol}://${this.host}`,
            headers: HttpHeaders,
            responseType: 'json',
            responseEncoding: 'utf8'
        })
            .catch((error) => {
            throw new utils_1.NetworkError(error.message);
        });
    }
    async get(endpoint) {
        return await axios_1.default
            .get(endpoint, {
            method: 'get',
            baseURL: `${this.protocol}://${this.host}`,
            headers: HttpHeaders,
            responseType: 'json',
            responseEncoding: 'utf8'
        })
            .catch((error) => {
            throw new utils_1.NetworkError(error.message);
        });
    }
}
exports.JuneoClient = JuneoClient;
class JsonRpcRequest {
    method;
    params;
    constructor(method, params = []) {
        this.method = method;
        this.params = params;
    }
    getJsonRpcObject(id) {
        return {
            jsonrpc: JsonRpcVersion,
            id,
            method: this.method,
            params: this.params
        };
    }
}
exports.JsonRpcRequest = JsonRpcRequest;
class JsonRpcResponse {
    jsonrpc;
    id;
    result;
    constructor(jsonrpc, id, result) {
        this.jsonrpc = jsonrpc;
        this.id = id;
        this.result = result;
    }
}
exports.JsonRpcResponse = JsonRpcResponse;
